import { useTranslation } from 'react-i18next';
import type { IAdminUser } from '@apis/adminUsers';
import { CheckListPick } from '@components/ui/CheckListPick/CheckListPick';
import styles from './AlertsHubTab.module.css';

export interface IRecipientsPickProps {
  /** The row's name, for the control's accessible name. */
  alertName: string;
  /** Who the viewer may pick from (`eligibleRecipients`). */
  eligible: IAdminUser[];
  /** The row's recipients the viewer can see (`visibleRecipients`). */
  recipients: string[];
  onToggle: (username: string, add: boolean) => void;
}

/** A Hub row's recipients: "N recipients" closed, a searchable checklist of the roster open. */
export function RecipientsPick({ alertName, eligible, recipients, onToggle }: IRecipientsPickProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.recipients}>
      <CheckListPick
        summary={t('alertSettings.hub.recipients', { count: recipients.length })}
        placeholder={t('alertSettings.hub.recipients', { count: 0 })}
        ariaLabel={t('alertSettings.hub.recipientsAria', { alert: alertName })}
        options={eligible.map((u) => ({ value: u.username, label: u.name ?? u.username, hint: u.email }))}
        selected={new Set(recipients)}
        onToggle={onToggle}
        searchPlaceholder={t('alertSettings.hub.searchUsers')}
        noMatches={t('alertSettings.hub.noUsers')}
      />
    </div>
  );
}
